/**
 * @file index.tsx
 *
 * @fileoverview Renders a row with source portals that the job comes from.
 */

import styles from "./sourcePortalsBadge.module.scss";
import GlobeIcon from "@jq-icons/Globe";
import Badge from "../../02-atoms/03-badge";

export interface SourcePortalsProps {
  /**
   * The list source portals.
   */
  sourcePortals?: string[];
}

export const SourcePortals = ({
  sourcePortals,
}: SourcePortalsProps) => {

  return (
    <div className={styles.sourcePortalsWrapper}>
      <span className={styles.sourcePortalsIcon}>
        <GlobeIcon color="secondary" title="source portals" />
      </span>
      {sourcePortals?.map((sourcePortal: string, index: number) => (
        <Badge key={index} badgeStyle={'primaryVeryLight'}>
          <span>{sourcePortal}</span>
        </Badge>
      ))}
    </div>
  );
};
export default SourcePortals;
